import * as actionTypes from '../types/workingDetailing';

// Добавление комментариев
export function workingDetailingAddCommit(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_ADD_COMMIT,
    payload
  };
}
export function workingDetailingAddCommitSuccess(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_ADD_COMMIT_SUCCESS,
    payload
  };
}
export function workingDetailingAddCommitFail(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_ADD_COMMIT_FAIL,
    payload
  };
}

// Удаление комментариев
export function workingDetailingDelCommit(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_DEL_COMMIT,
    payload
  };
}
export function workingDetailingDelCommitSuccess(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_DEL_COMMIT_SUCCESS,
    payload
  };
}
export function workingDetailingDelCommitFail(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_DEL_COMMIT_FAIL,
    payload
  };
}

// Получение списка комментариев
export function workingDetailingGetListCommits(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_LIST_COMMITS,
    payload
  };
}
export function workingDetailingGetListCommitsSuccess(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_LIST_COMMITS_SUCCESS,
    payload
  };
}
export function workingDetailingGetListCommitsFail(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_LIST_COMMITS_FAIL,
    payload
  };
}

// Добавление фото
export function workingDetailingAddPhoto(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_ADD_PHOTO,
    payload
  };
}
export function workingDetailingAddPhotoSuccess(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_ADD_PHOTO_SUCCESS,
    payload
  };
}
export function workingDetailingAddPhotoFail(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_ADD_PHOTO_FAIL,
    payload
  };
}

// Удаление фото
export function workingDetailingDelPhoto(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_DEL_PHOTO,
    payload
  };
}
export function workingDetailingDelPhotoSuccess(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_DEL_PHOTO_SUCCESS,
    payload
  };
}
export function workingDetailingDelPhotoFail(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_DEL_PHOTO_FAIL,
    payload
  };
}

// Получение списка фотографий
export function workingDetailingGetListPhotos(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_LIST_PHOTOS,
    payload
  };
}
export function workingDetailingGetListPhotosSuccess(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_LIST_PHOTOS_SUCCESS,
    payload
  };
}

export function workingDetailingGetListFilesSuccess(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_LIST_FILES_SUCCESS,
    payload
  };
}
export function workingDetailingGetListPhotosFail(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_LIST_PHOTOS_FAIL,
    payload
  };
}

// Скачивание фото
export function workingDetailingGetPhotoByte(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_PHOTO_BYTE,
    payload
  };
}
export function workingDetailingGetPhotoByteSuccess(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_PHOTO_BYTE_SUCCESS,
    payload
  };
}
export function workingDetailingGetPhotoByteFail(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_GET_PHOTO_BYTE_FAIL,
    payload
  };
}

// Отправка email
export function workingDetailingSendEmail(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_SEND_EMAIL,
    payload
  };
}
export function workingDetailingSendEmailSuccess(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_SEND_EMAIL_SUCCESS,
    payload
  };
}
export function workingDetailingSendEmailFail(payload) {
  return {
    type: actionTypes.WORKING_DETAILING_SEND_EMAIL_FAIL,
    payload
  };
}
